import { Action, createReducer, on } from '@ngrx/store';
import {
  assignExecutiveToInterestForm,
  changeInterestFormStatus,
  clearAllInterestForms,
  clearInterestForms,
  loadInterestForms,
  paginateInterestForm,
} from '../actions/leads/interestForm.action';

export const initialState: any = {
  fetching: false,
  data: {
    doctor: {
      data: [],
      totalDocuments: 0
    },
    diagnostic: {
      data: [],
      totalDocuments: 0
    },
    hospital: {
      data: [],
      totalDocuments: 0
    },
    pharmacy: {
      data: [],
      totalDocuments: 0
    },
    ambulance: {
      data: [],
      totalDocuments: 0
    },
    bloodBank: {
      data: [],
      totalDocuments: 0
    },
    contactLead: {
      data: [],
      totalDocuments: 0
    }
  }
};

const interestFormsReducer = createReducer(initialState,
  on(loadInterestForms, (state, { payload, key, totalDocuments }) => {

    return {
      ...state,
      data: {
        ...state.data,
        [key]: {
          data: [
            ...state.data[key].data,
            ...payload.filter(p => !state.data[key].data.find((ds: any) => ds._id === p._id))
          ],
          totalDocuments
        }
      }
    };
  }),
  on(clearAllInterestForms, (state, { key }) => {
    return {
      ...state,
      data: {
        ...state.data,
        [key]: {
          data: [],
          totalDocuments: 0
        }
      }
    };
  }),
  on(changeInterestFormStatus, (state, { ids, key, status }) => {
    return {
      ...state,
      data: {
        ...state.data,
        [key]: {
          ...state.data[key],
          data: state.data[key].data.map((d: any) => {
            if (ids.includes(d._id)) {
              return {
                ...d,
                status
              };
            }
            return d;
          }),
        }
      }
    };
  }),
  on(assignExecutiveToInterestForm, (state, { ids, key, payload }) => {
    return {
      ...state,
      data: {
        ...state.data,
        [key]: {
          ...state.data[key],
          data: state.data[key].data.map((d: any) => {
            if (ids.includes(d._id)) {
              return {
                ...d,
                _erp: payload,
                status: 'SALES_APPROVAL_PENDING'
              };
            }
            return d;
          }),
        }
      }
    };
  }),
  on(paginateInterestForm, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return interestFormsReducer(state, action);
}
